import { useForm, Controller } from "react-hook-form";
import { useMutation, useQueryClient } from "react-query";
import { toast } from "react-toastify";
import Select from "react-select";
import { unassignMemberFromExcoRole } from "../../utils/api-calls";
import { BackDrop } from "../Modals/AddMeeting";
import {
  ButtonContainer,
  CancelButton,
  Form,
  FormLabel,
  SubCon,
  SubConHeader,
  SubmitButton
} from "./Members.styles";

// Main Component
const UnassignExcoRoleModal = ({ close, closeParent, memberId, email, excoRoles }) => {
  const { control, handleSubmit, formState: { errors } } = useForm({
    defaultValues: {
      exco_role: null
    }
  });

  // Convert excoRoles to options format for the Select component
  const roleOptions = excoRoles.map(role => ({
    value: role.id,
    label: role.name
  }));

  const queryClient = useQueryClient();
  
  // Unassign Exco Role Mutation
  const { mutate, isLoading: submitLoading } = useMutation(
    (data) => unassignMemberFromExcoRole(data),
    {
      onSuccess: () => {
        toast.success("Successfully removed member from exco role", {
          progressClassName: "toastProgress",
          icon: false,
        });
        queryClient.invalidateQueries("all-excos");
        queryClient.invalidateQueries("all-members");
        close();
        closeParent();
      },
      onError: () => {
        toast.error("Failed to remove user from exco role");
      },
    }
  );

  const onSubmit = (data) => {
    mutate({
      member_id: memberId,
      exco_id: data.exco_role.value
    });
  };

  return (
    <BackDrop>
      <SubCon>
        <SubConHeader>Remove {email} from Exco</SubConHeader>
        {roleOptions.length === 0 ? (
          <div>
            <p>This member is not assigned to any exco role.</p>
            <ButtonContainer>
              <CancelButton type="button" onClick={close}>
                Close
              </CancelButton>
            </ButtonContainer>
          </div>
        ) : (
          <Form onSubmit={handleSubmit(onSubmit)}>            
            <FormLabel>
              Select Role to Remove:
              <Controller
                control={control}
                name="exco_role"
                rules={{ required: "Please select an exco role" }}
                render={({ field }) => (
                  <Select
                    {...field}
                    options={roleOptions}
                    placeholder="Select exco role"
                    isSearchable
                  />
                )}
              />
              {errors.exco_role && (
                <span style={{ color: "red", fontSize: "12px" }}>
                  {errors.exco_role.message}
                </span>
              )}
            </FormLabel>

            <ButtonContainer>
              <CancelButton type="button" onClick={close}>
                Cancel
              </CancelButton>
              <SubmitButton
                type="submit"
                disabled={submitLoading}
              >
                {submitLoading ? "Removing..." : "Remove"}
              </SubmitButton>
            </ButtonContainer>
          </Form>
        )}
      </SubCon>
    </BackDrop>
  );
};

export default UnassignExcoRoleModal;
